const initialState = {
  loading: null,
  data: null,
  error: [null, null],
  filters: {
    date: new Date().getMonth(),
  },
};

export default initialState;
